<h2 *ngIf="providerTitle; else logo">{{ providerTitle }}</h2>
<ng-template #logo>
    <mat-icon svgIcon="lad"></mat-icon>
</ng-template>

